"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMessage = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const Error_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Error/Error.svg"));
const ErrorDialog_1 = require("../../components/ErrorDialog");
const utils_1 = require("../utils");
const isResponseMessageObj = (message) => {
    return message.response !== undefined;
};
const isMessageObj = (message) => {
    return message.message !== undefined;
};
const isMessageString = (message) => {
    return message !== undefined;
};
const BASE_AJAX_ERROR_MESSAGE = 'ajax error';
const useMessage = ({ header: initialHeader = '', width: initialWidth = components_1.DIALOG_SIZE.xs, iconSrc: initialIconSrc = Error_svg_1.default, doneLabel: initialDoneLabel, cancelLabel: initialCancelLabel, onDone = utils_1.noop, onCancel, 
// @EvgenyKovrov: Deprecated
btnText, // new param: doneLabel
onClose = utils_1.noop, // new param: onDone
 } = {}) => {
    const initialOptions = react_1.useMemo(() => ({
        header: initialHeader,
        width: initialWidth,
        iconSrc: initialIconSrc,
        doneLabel: initialDoneLabel || btnText,
        cancelLabel: initialCancelLabel,
    }), []);
    const [message, setMessage] = react_1.useState('');
    const [options, setOptions] = react_1.useState(initialOptions);
    const [doneCallback, setDoneCallback] = react_1.useState();
    const [cancelCallback, setCancelCallback] = react_1.useState();
    const { width, header, iconSrc, doneLabel, cancelLabel } = options;
    const [dialog, actions] = components_1.useModal({
        render: ({ deactivate }) => (react_1.default.createElement(ErrorDialog_1.ErrorDialog, { width: width, header: header, iconSrc: iconSrc, errorText: message, btnText: btnText, doneLabel: doneLabel || btnText, cancelLabel: cancelLabel, deactivate: deactivate, onDone: doneCallback, onCancel: cancelCallback })),
    });
    const showMessage = (messageProps, showMessageOptions) => {
        var _a;
        const _b = showMessageOptions || {}, { onDoneCallback, onCancelCallback } = _b, baseOptions = __rest(_b, ["onDoneCallback", "onCancelCallback"]);
        let text;
        if (isResponseMessageObj(messageProps)) {
            text = (_a = messageProps.response) === null || _a === void 0 ? void 0 : _a.message;
        }
        else if (isMessageObj(messageProps)) {
            text = messageProps.message;
        }
        else if (isMessageString(messageProps)) {
            text = messageProps;
        }
        text = (text === null || text === void 0 ? void 0 : text.includes(BASE_AJAX_ERROR_MESSAGE)) ? '' : text;
        setMessage(text || '');
        setDoneCallback(() => typeof onDoneCallback === 'function' ? onDoneCallback : onDone || onClose);
        setCancelCallback(() => (typeof onCancelCallback === 'function' ? onCancelCallback : onCancel));
        setOptions(Object.assign(Object.assign({}, initialOptions), baseOptions));
        actions.activate();
    };
    return [dialog, showMessage];
};
exports.useMessage = useMessage;
//# sourceMappingURL=useMessage.js.map